// extracted by mini-css-extract-plugin
export var actionIcon = "_p9-0";